module.exports = __webpack_public_path__ + "static/media/clarinet.c05d1fd5.wav";